import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";

import { Space } from "antd";
import { MainLayout } from "components/layouts";
import MyTeamHeader from "./MyTeamHeader";
import MyTeamWorkSchedule from "./MyTeamWorkSchedule";

function MyTeam() {
  const { t } = useTranslation();

  return (
    <MainLayout
      title={t("my_team.header")}
      breadcrumb={[
        { title: t("home.header"), link: "/" },
        { title: t("my_team.header"), link: "/my_team" },
      ]}
    >
      {/* <MyTeamHeader /> */}
      {/* <MyTeamWorkSchedule /> */}
      <Outlet />
    </MainLayout>
  );
}

export default MyTeam;
